// vue-qrcode-reader@3.x picks cameras by POSITION in enumerateDevices() whenever
// more than two videoinput devices are exposed, ignoring facingMode entirely
// (narrowDownFacingMode, vue-qrcode-reader/src/misc/camera.js). On some older
// iPads both the first and last entries are front cameras, so the flip button
// toggles between the normal and ultra-wide front camera and the rear camera is
// never reachable.
//
// Capping the reported videoinput count at two forces the library down its other
// branch, which uses real facingMode constraints. Which two devices we leave in
// is irrelevant - that branch never reads the list.

let originalEnumerateDevices = null;
let refCount = 0;

export function installCameraDeviceShim() {
  refCount += 1;

  if (originalEnumerateDevices || !navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    return;
  }

  originalEnumerateDevices = navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);

  navigator.mediaDevices.enumerateDevices = async function () {
    const devices = await originalEnumerateDevices();
    let videoInputsKept = 0;

    return devices.filter((device) => {
      if (device.kind !== 'videoinput') return true;
      videoInputsKept += 1;
      return videoInputsKept <= 2;
    });
  };
}

export function uninstallCameraDeviceShim() {
  refCount = Math.max(0, refCount - 1);

  if (refCount > 0 || !originalEnumerateDevices) {
    return;
  }

  navigator.mediaDevices.enumerateDevices = originalEnumerateDevices;
  originalEnumerateDevices = null;
}
